export const CheckboxProps = (formik: any, name: string) => ({
  value: formik.values[name],
  onChange: formik.handleChange,
  setTouched: formik.getFieldHelpers(name).setTouched,
  error: formik.touched[name] ? formik.errors[name] : undefined,
})
